// Logo animation
//
// Move the logo when the content is scrolling

import { animate } from 'animejs'

export default {

    init() {

        // The following 2 lines fix the z-index problem when animating the logo,
        // but using the 2 lines causes positioning bugs.
        // document.querySelector('.nav--lang').style.position = 'absolute'
        // document.querySelector('.nav--lang').style.right = 0

        const moodLogo = document.getElementById('js-logo-mood')
        const headLogo = document.getElementById('js-logo-head')

        headLogo.style.right = '-72px'

        const state = window.getComputedStyle(document.body,':before').content.replace(/"/g, '')

        if (state == 'small' || state == 'medium' || !moodLogo) {
            animate([headLogo], {
                right: 0,
                duration: 1000,
                easing: 'easeOutCubic'
            })

            return
        }

        // Temporarily we work with fixed sizes.
        // headLogo width: 72px
        // moodLogo width: 343px
        const widthRelation = 72 / 343

        window.addEventListener('scroll', () => {
            moodLogo.style.right = (window.pageYOffset * -1) + 'px'

            // We only regard the scroll until the mood logo has left the viewport
            const scrollBound = window.pageYOffset < 343 ? window.pageYOffset : 343
            headLogo.style.right = (-72 + (scrollBound * widthRelation)) + 'px'
        })
    }
}
